// MODAL INITIALIZATION
const customBtn = document.querySelector("#customiseBtn");
const customBtn2 = document.querySelector('[color="custom-color"]');
const player = document.querySelector("#threeKit");
const attributes = document.querySelector("#dynamicAttributes");
const productName = document.querySelector('.product-single__title');

player.style.display = "none";
attributes.style.display = "none";

const productPrice = document.querySelector('.product__price').textContent.replace(/\s/g, '').replace('$', '')
  window.localStorage.setItem('productPrice', productPrice);

// ADDS SHOPIFY COLOR SELECTION(S) TO STORAGE
      if (document.querySelector("[customName=Color]:checked") != null) {
        const shopifyColorVariant = document.querySelector('[customName=Color]:checked').getAttribute('color');
        const shopifyColorName = document.querySelector('[customName=Color]:checked').value;
        sessionStorage.setItem("shopifyColor", shopifyColorVariant)
        sessionStorage.setItem("shopifyColorName", shopifyColorName)
        document.querySelector(".variant__label-info").innerHTML = shopifyColorName
      }

    const radioButtonSection = document.querySelectorAll("[customName=Color]");
      for (var i = 0; i < radioButtonSection.length; i++) {
        radioButtonSection[i].oninput = function() {
          sessionStorage.setItem("shopifyColor", this.getAttribute('color'));
          document.querySelector(".variant__label-info").innerHTML = this.value;
          sessionStorage.setItem("shopifyColorName", this.value);
        }
      }


const variantID = document.querySelectorAll("[name=Size]");
for (var i = 0; i < variantID.length; i++) {
        variantID[i].onchange = function() {
          const variant = document.querySelector('[name="id"] option:checked').value;
          const productPrice = document.querySelector(".product__price").innerHTML.replace('$', '');
          if (variant.value != variant ) {
            sessionStorage.setItem("shopifyFabricSize", variant);
            window.localStorage.setItem('productPrice', productPrice.toString());
          }   
        }
      }


document.addEventListener("readystatechange", function () {
    if (document.readyState === "complete") {
        customBtn.addEventListener("click", modalPopUp);
        customBtn2.addEventListener("click", modalPopUp);
    }
});
function modalPopUp() {
  // const tkAssetPre = localStorage.getItem('tkAssetPre')
  // const tkAsset = localStorage.setItem ('tkAsset', tkAssetPre)
// ADDS STOCK FABRIC PRICE/SELECT TO STORAGE
      if (document.querySelector('[name=Size]') != null) {
        const sizeSelected = document.querySelector("[name=Size]:checked").value
        sessionStorage.setItem("shopifySize", sizeSelected)
      }
      if (document.querySelector('[name=FabricPrice]') != null) {
        const shopifyFabricOptionName = document.querySelector('[name="id"] option:checked').value; 
        sessionStorage.setItem("shopifyFabricSize", shopifyFabricOptionName)
      }
      
      const popUp = document.createElement("div");
        popUp.id = 'popUp';
        popUp.style.display = "block";
        document.getElementById("customiser").appendChild(popUp);
        
      const content = document.createElement('div');
        content.id = "content";
        content.className = "modal-content";
        document.getElementById("popUp").appendChild(content);

      const closeBtn = document.createElement('div');
        closeBtn.innerHTML = "&times;";
        closeBtn.className = "close";
        closeBtn.id = "close";
        document.getElementById("content").appendChild(closeBtn);
        
      const masterDiv = document.createElement("div");
        masterDiv.id = "masterDiv"
        document.getElementById("content").appendChild(masterDiv);

      const loading = document.createElement('div');
        loading.className="loader";
        loading.id="loader";
        document.getElementById("masterDiv").appendChild(loading);

      const loadingImg = document.createElement("img");
        loadingImg.src = "https://scoutthumbnail.s3.us-east-2.amazonaws.com/Loading3.gif";
        document.getElementById("loader").appendChild(loadingImg);

      const loadingText = document.createElement("div");
        loadingText.className = "loadingText";
        loadingText.innerHTML += "bespoke is worth the wait...<br />"
        loadingText.innerHTML += "Rome wasn’t built in a day y’all";
        document.getElementById("loader").appendChild(loadingText);

      const rightModal = document.createElement("div");
        rightModal.id = "rightSide";
        document.getElementById("masterDiv").appendChild(rightModal);

      // TITLE
      const pageTitle = document.querySelector('.product-single__title').textContent
      const popUpTitle = document.createElement("h1");
        popUpTitle.className = 'h2 product-single__title';
        popUpTitle.innerText = pageTitle;
        document.getElementById("rightSide").appendChild(popUpTitle);

      // PRICE
      const pagePrice = document.querySelector(".product__price").textContent.replace(/\s/g, '').replace('$', '');
      const popUpPrice = document.createElement("span");
        popUpPrice.className = 'product__price2';
        popUpPrice.id = "threeKitPrice"
        popUpPrice.innerText = pagePrice;
        document.getElementById("rightSide").appendChild(popUpPrice);
        sessionStorage.setItem("priceSize", pagePrice.toString())

      const sizeButtonSection = document.querySelectorAll("[name=Size]");
      for (var i = 0; i < sizeButtonSection.length; i++) {
        sizeButtonSection[i].onchange = function() {
          const productPrice = document.querySelector(".product__price").innerHTML;
          if (popUpPrice.innerText != productPrice ) {
            popUpPrice.innerText = productPrice
          }   
        }
      }

      const fabricButtonSection = document.querySelectorAll('.ymq-attrib-8tem1');
      for (var i = 0; i < fabricButtonSection.length; i++) {
        fabricButtonSection[i].onchange = function() {
          const fabricPrice = document.querySelector(".product__price").innerHTML;
          if (popUpPrice.innerText != fabricPrice ) {
            popUpPrice.innerText = fabricPrice
          }   
        }
      }
      
      //APPENDS DYNAIMC ATTRIBUTES
      attributes.style.display = "block";
      document.getElementById("rightSide").appendChild(attributes);

      // CREATE ADD-TO-CART BUTTON
      const addToCartBtn = document.createElement("button");
        addToCartBtn.type = "submit";
        addToCartBtn.name = "add";
        addToCartBtn.id = "AddToCartThreeKit";
        addToCartBtn.className = "btn btn--full";
      const addToCartBtnText = document.createElement("span");
        addToCartBtnText.innerText = "Add To Cart"
      
      document.getElementById("rightSide").appendChild(addToCartBtn); 
      document.getElementById("AddToCartThreeKit").appendChild(addToCartBtnText); 

      const itemSet = (sessionStorage.getItem('configurator'));
      const spinner = document.querySelector('.loader')
        if (itemSet != '')  {
          spinner.remove();
        }
      
        player.style.display = "block";
        document.getElementById("masterDiv").appendChild(player);

      const body = document.querySelector("body");
        body.style.overflow = "hidden";
        
      const canvas = player.getElementsByTagName('canvas');
      canvas.width = '100%'

      sessionStorage.setItem('customProduct', 'Custom');
      
      // REMOVES SHOPIFY COLOR SELECTION(S)
  if (document.querySelector("[customName=Color]:checked") != null) {
    document.querySelector("[customName=Color]:checked").checked = false;
  }

      
      closeBtn.onclick = function() {
        sessionStorage.removeItem('customProduct');
        popUp.remove();
        body.style.overflow = "auto";
        // Remove ThreeKit Selections
        if (document.querySelector(".ymq-attrib-3tem1:checked") != null) {
          document.querySelector(".ymq-attrib-3tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-4tem1:checked") != null) {
          document.querySelector(".ymq-attrib-4tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-7tem1:checked") != null) {
          document.querySelector(".ymq-attrib-7tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-8tem1:checked") != null) {
          document.querySelector(".ymq-attrib-8tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-9tem1:checked") != null) {
          document.querySelector(".ymq-attrib-9tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-11tem1:checked") != null) {
          document.querySelector(".ymq-attrib-11tem1:checked").checked = false;
        }
        
        // Re-add Shopify selection(s)
        const shopifyColor = sessionStorage.getItem("shopifyColor");
        const shopifyFabricOptionName = sessionStorage.getItem("shopifyFabricSize");
        const shopifySize = sessionStorage.getItem("shopifySize");
        
        document.querySelector(`[color=${CSS.escape(shopifyColor)}]`).setAttribute("checked", "checked");
        document.querySelector(`[color=${CSS.escape(shopifyColor)}]`).checked = true;
        if (document.querySelector('[name=FabricPrice]') != null) {
          document.querySelector('[value="Stock Fabric"]').checked = true;
          const mySelect = document.querySelector('[name="id"]');
          mySelect.value = shopifyFabricOptionName;
          const price = document.querySelector('[name="id"] option:checked').getAttribute('data-value');
          document.querySelector('.product__price').innerText = price;
          if (sessionStorage.getItem("shopifySize") != null) {
            document.querySelector(`[value=${CSS.escape(shopifySize)}]`).checked = true;
          }
        }
      }
        
      window.onclick = function(event) {
        if (event.target == popUp){
          sessionStorage.removeItem('customProduct');
        popUp.remove();
        body.style.overflow = "auto";
        // Remove ThreeKit Selections
        if (document.querySelector(".ymq-attrib-3tem1:checked") != null) {
          document.querySelector(".ymq-attrib-3tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-4tem1:checked") != null) {
          document.querySelector(".ymq-attrib-4tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-7tem1:checked") != null) {
          document.querySelector(".ymq-attrib-7tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-8tem1:checked") != null) {
          document.querySelector(".ymq-attrib-8tem1:checked").checked = false;
        }
        if (document.querySelector(".ymq-attrib-11tem1:checked") != null) {
          document.querySelector(".ymq-attrib-11tem1:checked").checked = false;
        }
        
        // Re-add Shopify selection(s)
        const shopifyColor = sessionStorage.getItem("shopifyColor");
        const shopifyFabricOptionName = sessionStorage.getItem("shopifyFabricSize");
        const shopifySize = sessionStorage.getItem("shopifySize");
        document.querySelector(`[color=${CSS.escape(shopifyColor)}]`).setAttribute("checked", "checked");
        document.querySelector(`[color=${CSS.escape(shopifyColor)}]`).checked = true;
        if (document.querySelector('[name=FabricPrice]') != null) {
          document.querySelector('[value="Stock Fabric"]').checked = true;
          const mySelect = document.querySelector('[name="id"]');
          mySelect.value = shopifyFabricOptionName;
          const price = document.querySelector('[name="id"] option:checked').getAttribute('data-value');
          document.querySelector('.product__price').innerText = price;
          if (sessionStorage.getItem("shopifySize") != null) {
            document.querySelector(`[value=${CSS.escape(shopifySize)}]`).checked = true;
          }
        }
        }
      }
      
      const viewportWidth = window.innerWidth;
      if (viewportWidth <= 768) {
        const playerContainer = document.querySelector('#tk-ply-root')
        playerContainer.style.height = '120%';
      }

  addToCartBtn.addEventListener("click", function() {
    removeTooltips();
    const setPrice = document.querySelector('.product__price').innerText.replace('$', '');
      window.localStorage.setItem('productPrice', setPrice.toString()); 
  });
  
  setTimeout(() => { waitForPlayerToLoad(); }, 1000)
};


function hideSpinner() {
  const spinner = document.querySelector('#loader')
    spinner.classList.add('loader-hidden');
    spinner.addEventListener("transitionend", () => {
        spinner.remove(); 
    });
}

function waitForPlayerToLoad() {
    const playerSelector = document.querySelector('.arIcon___LBllM')
    const threekitLogo = document.querySelector('.logo___WOl4T');
    const arButton = document.querySelector(".arButton___uN6j2")
    const spinner = document.querySelector('#loader')
    if (playerSelector === null) {
        setTimeout(() => { waitForPlayerToLoad(); }, 0)
    } else {
      arButton.setAttribute('type', 'button');
      threekitLogo.style.display = 'none';
      if(spinner != null){
        setTimeout(() => { getAllAttributes(); hideSpinner(); }, 0) 
      }
      sessionStorage.setItem('configurator', 'loaded');
      // CHANGES DEFAULT AR TEXT
      const arBtnText = document.querySelector('.arButtonText___kg26U').textContent
        if (arBtnText != 'AR') {
          document.querySelector('.arButtonText___kg26U').textContent = 'AR'
        }
    }
};



        






